import type { INSTANTIATOR_INTERFACES } from '../../../model/interface/instantiator';

/* typing this was gives up typesafety, that we will always find a match for every INSTANTIATOR_INTERFACE */
const ENTITY_MAPPING: Record<keyof INSTANTIATOR_INTERFACES, Array<string>> = {
    IBackgroundModeDto: ['backgroundmodes', 'backgroundmode', 'backgroundmodedto'],
    IBeaconDto: ['beacons', 'beacon', 'beacondto'],
    IBeaconSensitivityDto: ['beaconsensitivities', 'beaconsensitivity', 'beaconsensitivitydto'],
    ICountryDto: ['country', 'countries', 'countrydto'],
    IDeviceAccountDto: ['deviceaccount', 'deviceaccounts', 'deviceaccountdto'],
    IFloorPlanDto: ['floorplans', 'floorplan', 'floorplandto'],
    IFloorPlanTourDto: ['floorplantours', 'floorplantour', 'floorplantourdto'],
    IFontAlignmentDto: ['fontalignments', 'fontalignment', 'fontalignmentdto'],
    IFontFamilyDto: ['fontfamilies', 'fontfamily', 'fontfamilydto'],
    IFontSizeUnitDto: ['fontsizeunits', 'fontsizeunit', 'fontsizeunitdto'],
    IFontStyleDto: ['fontstyles', 'fontstyle', 'fontstyledto'],
    IFloorPlanTranslationDto: [
        'floorplantranslation',
        'floorplantranslations',
        'floorplantranslationdto',
    ],
    ILanguageDto: ['languages', 'language', 'languagedto'],
    IMediumDto: ['media', 'medium', 'mediumdto'],
    IMenuItemKeywordDto: ['menuitemkeyword', 'menuitemkeywords', 'menuitemkeyworddto'],
    IMenuItemDto: ['menuitems', 'menuitem', 'menuitemdto'],
    IMenuItemTranslationDto: [
        'menuitemtranslations',
        'menuitemtranslation',
        'menuitemtranslationdto',
    ],
    IPinTypeDto: ['pintypes', 'pintype', 'pintypedto'],
    IRoleDto: ['role', 'roles', 'roledto'],
    IScreenOrientationDto: ['screenorientations', 'screenorientation', 'screenorientationdto'],
    ISiteDto: ['sites', 'site', 'sitedto'],
    ISiteObjectOnFloorPlanDto: [
        'siteobjectonfloorplans',
        'siteobjectonfloorplan',
        'siteobjectonfloorplandto',
    ],
    ISiteObjectDto: ['siteobjects', 'siteobject', 'siteobjectdto'],
    ISiteObjectKeywordDto: ['siteobjectkeywords', 'siteobjectkeyword', 'siteobjectkeyworddto'],
    ISiteObjectTranslationDto: [
        'siteobjecttranslations',
        'siteobjecttranslation',
        'siteobjecttranslationdto',
    ],
    ISiteObjectTypeDto: ['siteobjecttypes', 'siteobjecttype', 'siteobjecttypedto'],
    ISiteSupportedLanguageDto: [
        'sitesupportedlanguages',
        'sitesupportedlanguage',
        'sitesupportedlanguagedto',
    ],
    IStyleDto: ['styles', 'style', 'styledto'],
    ITourRelatedSiteObjectDto: [
        'tourrelatedsiteobjects',
        'tourrelatedsiteobject',
        'tourrelatedsiteobjectdto',
    ],
    ITourDto: ['tours', 'tour', 'tourdto'],
    ITourMenuItemDto: ['tourmenuitem', 'tourmenuitems', 'tourmenuitemdto'],
    ITourStatusDto: ['tourstatuses', 'tourstatus', 'tourstatusdto'],
    ITourSubTypeDto: ['toursubtypes', 'toursubtype', 'toursubtypedto'],
    ITourSupportedLanguageDto: [
        'toursupportedlanguages',
        'toursupportedlanguage',
        'toursupportedlanguagedto',
    ],
    ITourTranslationDto: ['tourtranslations', 'tourtranslation', 'tourtranslationdto'],
    ITourTypeDto: ['tourtypes', 'tourtype', 'tourtypedto'],
    IUserDto: ['users', 'user', 'userdto'],

    ILegacy_FloorPlanDto: ['legacy_floorplan', 'legacy_floorplans', 'legacy_floorplandto'],
};

/* However rebuild at runtime (swap k->v) for quicker lookup times */
const LOOKUP_MAP: Record<string, keyof INSTANTIATOR_INTERFACES> = {};
let LOOKUP_MAP_BUILT = false;

function _buildMap() {
    for (const entityname of Object.keys(ENTITY_MAPPING) as Array<keyof INSTANTIATOR_INTERFACES>) {
        const patchPaths = ENTITY_MAPPING[entityname];

        patchPaths.forEach(path => {
            LOOKUP_MAP[path] = entityname;
        });
    }
}

function entityNameFromPatchPath(path: string): keyof INSTANTIATOR_INTERFACES | null {
    if (!LOOKUP_MAP_BUILT) {
        LOOKUP_MAP_BUILT = true;
        _buildMap();
    }

    let pathCompare = path.toLowerCase();

    if (path.startsWith('/')) {
        pathCompare = pathCompare.slice(1);
    }

    return LOOKUP_MAP[pathCompare];
}

export default entityNameFromPatchPath;
